import BadRequestHttpError from "../BadRequestHttpError";
import IValidationHttpErrorResponse from "../../interfaces/BadRequest/IValidationHttpErrorResponse";

export default class ValidationHttpError extends BadRequestHttpError<IValidationHttpErrorResponse> {
    constructor(response: IValidationHttpErrorResponse) {
        super("Validation error!", response);
    }
}
